import Vue from 'vue';
import Vuex from 'vuex';
import { AuthModule, AuthState } from './auth.store';
import { DeviceState, DeviceModule } from './device.store';
import { SocketState, SocketModule } from './socket.store';
import { ChatState, ChatModule } from './chat.store';
import { CampaignState, CampaignModule } from './campaign.store';
import { CampaignMessageState, CampaignMessageModule } from './campaignMessage.store';
import { MessageState, MessageModule } from './message.store';
import { TeamState, TeamModule } from './team.store';
import { UserState, UserModule } from './user.store';
import { ChatTabState, ChatTabModule } from './chatTab.store';
import { MessageTemplateState, messageTemplateModule } from './messageTemplate.store';
import { SnackbarState, SnackbarModule } from './snackbar.store';
import { RetailerState, RetailerModule } from './retailer.store';
import { RolesState, RolesModule } from './roles.store';
import { IntegrationState, IntegrationModule } from './integration.store';
import { BotState, BotModule } from './bot.store';
import { FeatureFlagState, FeatureFlagModule } from './featureFlag.store';
import { DashboardState, DashboardModule } from './dashboard.store';

export interface RootState {
  auth: AuthState;
  device: DeviceState;
  socket: SocketState;
  chat: ChatState;
  chatTab: ChatTabState;
  message: MessageState;
  campaign: CampaignState;
  campaignMessage: CampaignMessageState;
  team: TeamState;
  user: UserState;
  messageTemplate: MessageTemplateState;
  snackbar: SnackbarState;
  retailer: RetailerState;
  roles: RolesState;
  integration: IntegrationState;
  bot: BotState;
  featureFlag: FeatureFlagState;
  dashboard: DashboardState;
}

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  modules: {
    auth: AuthModule,
    device: DeviceModule,
    socket: SocketModule,
    chat: ChatModule,
    chatTab: ChatTabModule,
    message: MessageModule,
    campaign: CampaignModule,
    campaignMessage: CampaignMessageModule,
    team: TeamModule,
    user: UserModule,
    messageTemplate: messageTemplateModule,
    snackbar: SnackbarModule,
    retailer: RetailerModule,
    roles: RolesModule,
    integration: IntegrationModule,
    bot: BotModule,
    featureFlag: FeatureFlagModule,
    dashboard: DashboardModule,
    app: {
      state: {
        version: process.env.PACKAGE_VERSION || '0',
      },
    },
  },
});
